  (() => {
    const initSellOutSections = () => {
      const sections = document.querySelectorAll('.product-offer__sell-out');

      sections.forEach(section => {
        if (section.dataset.sellOutInitialized === 'true') return;

        section.dataset.sellOutInitialized = 'true';

        const counter = section.querySelector('.sell-out__counter span');
        const bar = section.querySelector('.sell-out__item-bar-inner');
        const timer = section.querySelector('.sell-out__timer');

        if (counter) {
          const target = parseInt(counter.dataset.counter, 10);

          if (!isNaN(target)) {
            const animateCount = () => {
              const duration = 1500;
              const startTime = performance.now();

              const step = currentTime => {
                const progress = Math.min(
                  (currentTime - startTime) / duration,
                  1
                );

                const value = Math.floor(progress * target);

                counter.textContent = value.toLocaleString();

                if (progress < 1) {
                  requestAnimationFrame(step);
                } else {
                  counter.textContent = target.toLocaleString();
                }
              };

              requestAnimationFrame(step);
            };

            const counterObserver = new IntersectionObserver(
              entries => {
                entries.forEach(entry => {
                  if (entry.isIntersecting) {
                    animateCount();
                    counterObserver.unobserve(counter);
                  }
                });
              },
              {
                threshold: 0.5
              }
            );

            counterObserver.observe(counter);
          }
        }

        if (bar) {
          const targetWidth = parseInt(bar.dataset.width, 10);

          if (!isNaN(targetWidth)) {
            const animateBar = () => {
              bar.style.width = '0%';
              bar.style.transition = 'width 1.5s ease';

              requestAnimationFrame(() => {
                bar.style.width = `${targetWidth}%`;
              });
            };

            const barObserver = new IntersectionObserver(
              entries => {
                entries.forEach(entry => {
                  if (entry.isIntersecting) {
                    animateBar();
                    barObserver.unobserve(bar);
                  }
                });
              },
              {
                threshold: 0.5
              }
            );

            barObserver.observe(bar);
          }
        }

        if (timer) {
          const countdown = timer.querySelector('span');
          const countdownDate = timer.dataset.countdownDate;

          if (!countdown || !countdownDate) return;

          const finalDate = new Date(countdownDate);

          if (isNaN(finalDate.getTime())) {
            countdown.textContent = '00:00:00';
            return;
          }

          const updateTimer = () => {
            const now = new Date();
            const timeDifference = finalDate - now;

            if (timeDifference <= 0) {
              countdown.textContent = '00:00:00';
              return;
            }

            const hours = Math.floor(
              (timeDifference % (1000 * 60 * 60 * 24)) /
              (1000 * 60 * 60)
            );

            const minutes = Math.floor(
              (timeDifference % (1000 * 60 * 60)) /
              (1000 * 60)
            );

            const seconds = Math.floor(
              (timeDifference % (1000 * 60)) /
              1000
            );

            countdown.textContent =
              String(hours).padStart(2, '0') + ':' +
              String(minutes).padStart(2, '0') + ':' +
              String(seconds).padStart(2, '0');

            setTimeout(updateTimer, 1000);
          };

          updateTimer();
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSellOutSections);
    } else {
      initSellOutSections();
    }

    document.addEventListener('shopify:section:load', initSellOutSections);
    document.addEventListener('shopify:block:select', initSellOutSections);
  })();